module.exports = __webpack_public_path__ + "img/studio-5.5505c23b.jpg";